import React from "react";
import styles from "../../assets/styles/styles.less";
import MediaQuery from "react-responsive";

import HowItWorksDesktop from "./HowItWorksDesktop";
import HowItWorksMobile from "./HowItWorksMobile";

const HowItWorks = () => (
  <div className="how-container">
    <MediaQuery maxDeviceWidth={740}>
      <HowItWorksMobile />
    </MediaQuery>
    <MediaQuery minDeviceWidth={741}>
      <HowItWorksDesktop />
    </MediaQuery>
  </div>
);

export default HowItWorks;



// WEBPACK FOOTER //
// ./components/HowItWorks/HowItWorks.js